import createReducer from "Common/reducerUtils/createReducer";
import isEqual from "lodash/isEqual";
import keyBy from "lodash/keyBy";
import map from "lodash/map";
import omit from "lodash/omit";
import { NAMESPACE } from "../constants";
import roleFactory from "../utils/roleFactory";
import actionTypes from "./actionTypes";
export const initialState = {
    [NAMESPACE]: {
        list: undefined
    }
};
export default createReducer(initialState, {
    [actionTypes.GET_ROLES_COMPLETED]: (state, { payload }) => {
        const list = keyBy(map(payload, roleFactory), "Id");
        if (isEqual(state[NAMESPACE].list, list))
            return state;
        return {
            ...state,
            [NAMESPACE]: {
                ...state[NAMESPACE],
                list
            }
        };
    },
    [actionTypes.REMOVE_ROLES_COMPLETED](state, { meta }) {
        return {
            ...state,
            [NAMESPACE]: {
                ...state[NAMESPACE],
                list: omit(state[NAMESPACE].list, meta.ids)
            }
        };
    },
    [actionTypes.SAVE_ROLE_COMPLETED]: (state, { payload }) => state[NAMESPACE].list
        ? {
            ...state,
            [NAMESPACE]: {
                ...state[NAMESPACE],
                list: {
                    ...state[NAMESPACE].list,
                    [payload.Id]: roleFactory(payload)
                }
            }
        }
        : state
});
